import React, {useState} from 'react'

import trash from '../../Assets/Icons/trash.svg'
import panierMoins from '../../Assets/Icons/panierMoins.svg'
import panierMoinsDisabled from '../../Assets/Icons/panierMoinsDisabled.svg'
import panierPlus from '../../Assets/Icons/panierPlus.svg'

import './PanierItem.scss'
import {OrderProductModel} from "../../Models/OrderModel";
import Deposit from "../../Assets/Icons/deposit.svg";
import Error from "../Error/Error";
import {useTranslation} from "react-i18next";
import {useFormatCurrency} from "../../hooks/useFormatCurrency";

interface MenuItemProps {
    item: OrderProductModel,
    onMinusClick: () => void,
    onPlusClick: () => void,
    onDeleteClick: () => void,
}

const PanierItem: React.FC<MenuItemProps> = ({item, onMinusClick, onPlusClick, onDeleteClick}: MenuItemProps) => {
    const {t} = useTranslation('common')
    const formatCurrency = useFormatCurrency()
    const [showConsigne, setShowConsigne] = useState<boolean>(false)

    return (
        <div className="panierItem">
            <div className="panierItem__item">
                <div className="panierItem__item__cadre">
                    <img
                        src={item.product.image}
                        alt="item"
                    />
                </div>
                <div className="panierItem__item__infos">
                    <p className="panierItem__item__infos--name">{item.name}</p>
                    <p className="panierItem__item__infos--prix">{formatCurrency(item.totalPriceTTC)}</p>
                </div>
                <div className="panierItem__item__actions">
                    <img className="panierItem__item__actions--delete" src={trash} alt={t('alt.delete')}
                         onClick={onDeleteClick}/>
                    <div className="panierItem__item__actions__quantitee">
                        <img className="panierItem__item__actions__quantitee--moins"
                             src={item.quantity && item.quantity > 1 ? panierMoins : panierMoinsDisabled}
                             alt={t('alt.decreaseQuantity')} onClick={onMinusClick}/>
                        <p className="panierItem__item__actions__quantitee--txt">{item.quantity}</p>
                        <img className="panierItem__item__actions__quantitee--plus" src={panierPlus} alt={t('alt.increaseQuantity')}
                             onClick={onPlusClick}/>
                    </div>
                </div>
            </div>
            {
                item?.totalDepositPriceTTC !== 0 && (
                    <>
                        <div className="panierItem__deposit" onClick={() => setShowConsigne(true)}>
                            <img src={Deposit} alt={t('alt.depositIcon')}/>
                            <p>{t('deposit.label', {price: formatCurrency(item.totalDepositPriceTTC)})}</p>
                        </div>
                        <Error
                            show={showConsigne}
                            close={() => setShowConsigne(false)}
                            title={t('deposit.title', {price: formatCurrency(item.totalDepositPriceTTC)})}
                            subTitle={t('deposit.subtitle')}
                            btnTxt={t('actions.understood')}
                        />
                    </>
                )
            }
        </div>
    )
}

export default PanierItem;
